import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'hiv_aids_status_real_perceived_1'

export const dataPointDefinition = {
  retracedId: 'hiv_aids_status_real_perceived_1',
  name: 'HIV / AIDS Status (real or perceived)',
  description:
    'HIV/AIDS Status (real or perceived) refers to a person�s actual or perceived infection with HIV/AIDS. HIV refers to the Human Immunodeficiency Virus, a virus that weakens the body�s immune system, ultimately causing AIDS, which is the Acquired Immune Deficiency Syndrome, a cluster of medical conditi',
  meta: {
    slcpMeta: {
      key: 'disc-6--8',
      number: 'WT-DIS-6-8',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'wt-dis-4',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[1],wt-dis-3,Yes',
      machineShowHide: '[1],wt-dis-3,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'disc-6--8', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26720,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
